import App from '../App/App';

export {getStaticProps} from '@amplify/abflag';

export default App;
